// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/places_of_worship.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/places_of_worship.proto.
 */
export const file_proto_model_core_place_types_places_of_worship = /*@__PURE__*/
  fileDesc("CjRwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL3BsYWNlc19vZl93b3JzaGlwLnByb3RvEgZjYXJtZW4q9QEKGFBsYWNlc09mV29yc2hpcFBsYWNlVHlwZRIsCihQTEFDRVNfT0ZfV09SU0hJUF9QTEFDRV9UWVBFX1VOU1BFQ0lGSUVEEAASJwojUExBQ0VTX09GX1dPUlNISVBfUExBQ0VfVFlQRV9DSFVSQ0gQARItCilQTEFDRVNfT0ZfV09SU0hJUF9QTEFDRV9UWVBFX0hJTkRVX1RFTVBMRRACEicKI1BMQUNFU19PRl9XT1JTSElQX1BMQUNFX1RZUEVfTU9TUVVFEAMSKgomUExBQ0VTX09GX1dPUlNISVBfUExBQ0VfVFlQRV9TWU5BR09HVUUQBEIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the enum carmen.PlacesOfWorshipPlaceType.
 */
export const PlacesOfWorshipPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_places_of_worship, 0);

/**
 * Places of worship place types
 *
 * @generated from enum carmen.PlacesOfWorshipPlaceType
 */
export const PlacesOfWorshipPlaceType = /*@__PURE__*/
  tsEnum(PlacesOfWorshipPlaceTypeSchema);

